import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Modal from './modals/modal.component';

class ConfirmDialog extends PureComponent {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDiscard: PropTypes.func,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.string,
    dismissText: PropTypes.string,
    submitText: PropTypes.string,
    className: PropTypes.string,
    isVisible: PropTypes.bool,
    isSubmitDisabled: PropTypes.bool,
  };

  static defaultProps = {
    message: <span>Changes you made may not be saved.</span>,
    title: 'Do you want to leave this page?',
    dismissText: 'Stay',
    submitText: 'Leave',
    isSubmitDisabled: false,
  };

  render() {
    const {
      onCancel,
      onConfirm,
      message,
      title,
      dismissText,
      submitText,
      className,
      isVisible,
      onDiscard,
      isSubmitDisabled,
      ...rest
    } = this.props;

    const additionalProps = onDiscard ? {
      submitAndAddAnotherText: 'Discard',
      submitAndAddAnotherAction: () => {
        onDiscard();
        onConfirm();
      },
    }: {};

    return (
      <Modal
        className={classnames('confirm-dialog-modal', className)}
        title={title}
        closeAction={onCancel}
        dismissText={dismissText}
        dismissAction={onCancel}
        submitText={submitText}
        submitAction={onConfirm}
        isVisible={isVisible}
        submitDisabled={isSubmitDisabled}
        {...additionalProps}
        {...rest}
      >
        <div>
          {message}
        </div>
      </Modal>
    );
  }
}

export default ConfirmDialog;
